import React from 'react'

import PropTypes from 'prop-types'

import AtomTooltip, {AtomTooltipPlacements} from '@s-ui/react-atom-tooltip'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import IconInfoOutline from '@adv-mt/mt-svg-icons/lib/InfoOutline'

function FormFieldTooltip({content}) {
  const isDesktop = useMediaQuery(useMediaQueryBreakpoints.lg)
  const tooltipPlacement = isDesktop ? AtomTooltipPlacements.RIGHT : AtomTooltipPlacements.BOTTOM

  const iconProps = {
    size: 'medium',
    color: 'primary'
  }

  return (
    <AtomTooltip placement={tooltipPlacement} content={content}>
      <div>
        <IconInfoOutline aria-hidden role="presentation" {...iconProps} />
      </div>
    </AtomTooltip>
  )
}

FormFieldTooltip.displayName = 'FormFieldTooltip'
FormFieldTooltip.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.func]).isRequired
}

export default FormFieldTooltip
